// extracted by mini-css-extract-plugin
module.exports = {"action":"Action_action__2czKw","action-delete":"Action_action-delete__3Vp1o","action-rename":"Action_action-rename__Yiu6q","inactive":"Action_inactive__3_rAh"};